import ValidateSession from '@/features/user/pages/ValidateSession.vue';
import TermsAcceptance from '@/features/user/pages/TermsAcceptance.vue';

export default [
  {
    path: '/volunteers/validate-session',
    component: ValidateSession,
    name: 'ValidateSession',
    meta: {
      public: true
    }
  },
  {
    path: '/volunteers/terms-of-services',
    component: TermsAcceptance,
    name: 'TermsAcceptance'
  }
];
